import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const otherDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOtherDocumentDetails: builder.query({
      query: () => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.GET_DOCUMENT_DETAILS,
        method: "GET",
      }),
      providesTags: [{ type: "documentDetails", id: "LIST" }],
    }),

    updateDocument: builder.mutation({
      query: (formdata) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.UPDATE_DOCUMENT,
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    //API FOR HR
    hrGetOtherDocumentDetails: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.HR_GET_DOCUMENT_DETAILS(empId),
        method: "GET",
      }),
      providesTags: [{ type: "documentDetails", id: "LIST" }],
    }),

    hrUpdateDocument: builder.mutation({
      query: ({ empId, formdata }) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.HR_UPDATE_DOCUMENT(empId),
        method: "PUT",
        body: formdata,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),
    documentDownload: builder.query({
      query: ({ folder, file }) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.DOCUMENT_DOWNLOAD(folder, file),
        method: "GET",
        responseHandler: (response) => response.blob(), // ✅ Force blob
      }),
    }),
    qcUpdateStatus: builder.mutation({
      query: (payload) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.QC_UPDATE_STATUS,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
    }),
    qcOverallStatus: builder.mutation({
      query: (payload) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.QC_OVERALL_STATUS,
        method: "PUT",
        params: payload,
      }),
      invalidatesTags: [{ type: "documentDetails", id: "LIST" }],
    }),
    qcStatusReport: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.QC_STATUS_REPORT_FILTERED,
        method: "GET",
        params,
      }),
    }),
    qcStatusReportExport: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.QC_STATUS_REPORT_EXPORT,
        method: "GET",
        params,
        responseHandler: (response) => response.blob(),
      }),
    }),

     accountupdateReport: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.ACCOUNT_REPORT_FILTERED,
        method: "GET",
        params,
      }),
    }),

      accountUpdateExport: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.OTHER_DOCUMENTS.ACCOUNT_REPORT_EXPORT,
        method: "GET",
        params,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetOtherDocumentDetailsQuery,
  useUpdateDocumentMutation,
  useHrGetOtherDocumentDetailsQuery,
  useHrUpdateDocumentMutation,
  useLazyDocumentDownloadQuery,
  useQcUpdateStatusMutation,
  useQcOverallStatusMutation,
  useQcStatusReportQuery,
  useLazyQcStatusReportExportQuery,
  useAccountupdateReportQuery,
  useLazyAccountUpdateExportQuery,
} = otherDocumentsApi;
